import Entity from "./entity";
import Fightable from "./fightable";
import Glyphs from "./glyphs";
import Component from "./component";
import Speed from "./speed";
import Mass from "./mass";
import Health from "./health";
import Equipment from "./equipment";
import Weapons from "./weapons";
import Armor from "./armor";
import Statblock from "./statblock";
import * as behaviour from "./behaviour";
import { grammar } from "calyx";
//import { manhattanDistance } from "./grid";

function manhattanDistance(start, end) {
  return Math.abs(start.x - end.x) + Math.abs(start.y - end.y);
}

const gremlinNames = grammar({
  start: ["{unter_prefix}unter", "{arter_prefix}arter"],
  unter_prefix: ["M", "P", "Bl", "R", "G"],
  arter_prefix: ["Sh", "F", "Cz", "Dj"]
});

const abilityScore = grammar({
  modifier: ["-3", "-2", "-1", "0", "+1", "+2", "+3"],
  attackRoll: ["1d6", "2d4", "2d6", "3d4"]
});

class GremlinBehaviour extends Component {
  static SLEEP = 0;
  static FEED = 1;
  static IDLE = 2;
  static SENSE = 3;

  constructor() {
    super();
    this.state = GremlinBehaviour.SLEEP;
  }

  isSleeping() {
    return this.state == GremlinBehaviour.SLEEP;
  }

  isFeeding() {
    return this.state == GremlinBehaviour.FEED;
  }

  isIdling() {
    return this.state == GremlinBehaviour.IDLE;
  }

  isSensing() {
    return this.state == GremlinBehaviour.SENSE;
  }

  handleBumpFrom(entity) {
    switch (this.state) {
      case GremlinBehaviour.SLEEP:
        console.log(`${this.owner.name} has woken up`);
        this.state = GremlinBehaviour.SENSE;
      break;
    }
  }

  takeTurn(stage) {
    if (this.isSensing()) {
      console.log(`takeTurn: ${this.owner.name} is sensing`);

      // If player can see this entity then assume it can see player too
      if (stage.isVisible(this.owner.x, this.owner.y)) {

        // Player is the target (for now)
        const targetDistance = manhattanDistance(this.owner, stage.player);

        if (targetDistance == 4) {
          behaviour.yeet(this.owner, stage.player, stage)
        } else {
          behaviour.meleeCharge(this.owner, stage.player, stage);
        }

      } else {
        behaviour.drunkenWalk(this.owner, stage);
      }
    }

    if (this.isSleeping()) {
      console.log(`takeTurn: ${this.owner.name} is sleeping`);
    }

    if (this.isFeeding()) {
      console.log(`takeTurn: ${this.owner.name} is feeding`);
    }

    if (this.isIdling()) {
      console.log(`takeTurn: ${this.owner.name} is idling`);
      behaviour.drunkenWalk(this.owner, stage);
    }
  }
}

class MonsterSense extends Component {
  takeTurnFleeIfScared(stage) {
    // If player can see this monster then assume it can see player too
    if (stage.isVisible(this.owner.x, this.owner.y)) {
      if (this.owner.health.isInjured()) {
        behaviour.scatterAndFlee(this.owner, stage.player, stage);
      } else {
        behaviour.meleeCharge(this.owner, stage.player, stage);
      }
    }
  }

  takeTurn(stage) {
    // Aggressive version where the monster always attacks
    if (stage.isVisible(this.owner.x, this.owner.y)) {
      behaviour.meleeCharge(this.owner, stage.player, stage);
    }
  }
}

function spawnGremlin(x, y, dramaManager) {
  const name = gremlinNames.generate();

  return new Entity(x, y, Glyphs.GREMLIN, name.text, {
    mass: new Mass(Mass.Small),
    speed: new Speed(5),
    health: new Health(10),
    sense: new MonsterSense(),
    stats: new Statblock(12, 12, 12),
    equipment: new Equipment(Weapons.Spear, Armor.Leather)
  });
}

export {
  spawnGremlin
}
